module.exports = __webpack_public_path__ + "08ef2ecf738c75dc598694f6a706dc85.svg";